import { DietIdEnum, DietModeType } from '@front-activerse/common-components';
import { dietSettings } from '@front-activerse/modules';

export const DIET_TYPES = [
  {
    id: 4,
    value: DietIdEnum.DIET_ID_CLASSIC,
    optionTitle: 'app.nutritionSettings.dietType.optionClassic.title',
    optionDescription: 'app.nutritionSettings.dietType.optionClassic.description',
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 18,
    value: DietIdEnum.DIET_ID_VEGE,
    optionTitle: 'app.nutritionSettings.dietType.optionVege.title',
    optionDescription: 'app.nutritionSettings.dietType.optionVege.description',
    macro: {
      protein: 22,
      fat: 30,
      carbs: 48,
    },
  },
  {
    id: 5,
    value: DietIdEnum.DIET_ID_GLUTEN_DAIRY_FREE,
    optionTitle: 'app.nutritionSettings.dietType.optionGlutenDairyFree.title',
    optionDescription: 'app.nutritionSettings.dietType.optionGlutenDairyFree.description',
    macro: {
      protein: 20,
      fat: 30,
      carbs: 50,
    },
  },
  {
    id: 6,
    value: DietIdEnum.DIET_ID_GLP1,
    optionTitle: 'app.nutritionSettings.dietType.optionGLP1.title',
    optionDescription: 'app.nutritionSettings.dietType.optionGLP1.description',
    macro: {
      protein: '25-30',
      fat: 30,
      carbs: '40-45',
    },
    disableCondition: (values: dietSettings) =>
      values.dietMode === DietModeType.stabilization ||
      values.dietMode === DietModeType.gain_muscle_mass,
  },
  {
    id: 7,
    value: DietIdEnum.DIET_ID_GLP1,
    optionTitle: 'app.nutritionSettings.dietType.optionGLP1.title',
    optionDescription: 'app.nutritionSettings.dietType.optionGLP1.description',
    macro: {
      protein: '25-30',
      fat: 30,
      carbs: '40-45',
    },
    renderCondition: (values: any) => values.dietType === DietIdEnum.DIET_ID_GLP1_CLASSIC,
    disableCondition: (values: dietSettings) =>
      values.dietMode === DietModeType.stabilization ||
      values.dietMode === DietModeType.gain_muscle_mass,
  },
];

export const DIET_LEVELS = [
  {
    id: 7,
    value: DietIdEnum.DIET_ID_GLP1_CLASSIC,
    optionTitle: 'app.nutritionSettings.dietLevel.dietGLP1Classic.title',
    optionDescription: 'app.nutritionSettings.dietLevel.dietGLP1Classic.description',
    macro: {
      protein: 30,
      fat: 30,
      carbs: 40,
    },
  },
  {
    id: 6,
    value: DietIdEnum.DIET_ID_GLP1_FRIENDLY,
    optionTitle: 'app.nutritionSettings.dietLevel.dietGLP1Friendly.title',
    optionDescription: 'app.nutritionSettings.dietLevel.dietGLP1Friendly.description',
    macro: {
      protein: 25,
      fat: 30,
      carbs: 45,
    },
  },
];

export const DIET_MODES = [
  {
    value: DietModeType.slimming,
    optionTitle: 'app.goalSettings.goal.optionWeightLoss.title',
    optionDescription: 'app.goalSettings.goal.optionWeightLoss.description',
  },
  {
    value: DietModeType.stabilization,
    optionTitle: 'app.goalSettings.goal.optionWeightMaintain.title',
    optionDescription: 'app.goalSettings.goal.optionWeightMaintain.description',
    disableCondition: (values: dietSettings) =>
      values.dietType === DietIdEnum.DIET_ID_GLP1 ||
      values.dietType === DietIdEnum.DIET_ID_GLP1_FRIENDLY ||
      values.dietType === DietIdEnum.DIET_ID_GLP1_CLASSIC,
  },
  {
    value: DietModeType.gain_muscle_mass,
    optionTitle: 'app.goalSettings.goal.optionBuildMuscle.title',
    optionDescription: 'app.goalSettings.goal.optionBuildMuscle.description',
    disableCondition: (values: dietSettings) =>
      values.dietType === DietIdEnum.DIET_ID_GLP1 ||
      values.dietType === DietIdEnum.DIET_ID_GLP1_FRIENDLY ||
      values.dietType === DietIdEnum.DIET_ID_GLP1_CLASSIC,
  },
];

// for i18n-unused
// t('app.goalSettings.dietType.optionClassic.title')
// t('app.goalSettings.dietType.optionClassic.description')
// t('app.goalSettings.dietType.optionVeggie.title')
// t('app.goalSettings.dietType.optionVeggie.description')
// t('app.goalSettings.dietType.optionVegan.title')
// t('app.goalSettings.dietType.optionVegan.description')
// t('app.goalSettings.dietType.optionHighProtein.title')
// t('app.goalSettings.dietType.optionHighProtein.description')
// t('app.goalSettings.dietType.optionGLP1.title')
// t('app.goalSettings.dietType.optionGLP1.description')

// t('app.goalSettings.goal.optionWeightLoss.title')
// t('app.goalSettings.goal.optionWeightLoss.description')
// t('app.goalSettings.goal.optionWeightMaintain.title')
// t('app.goalSettings.goal.optionWeightMaintain.description')
// t('app.goalSettings.goal.optionBuildMuscle.title')
// t('app.goalSettings.goal.optionBuildMuscle.description')
